// src/components/services/ValuePropositionSection.js
import React from 'react';
// Imports Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

// Styles Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import './ValuePropositionSection.css';

const valuePoints = [
  {
    id: 'vp1',
    icon: '💡',
    title: "Solutions Innovantes & Sur Mesure",
    description: "Nous ne nous contentons pas de suivre les tendances, nous créons des solutions web personnalisées qui répondent précisément à vos enjeux et anticipent vos besoins futurs."
  },
  {
    id: 'vp2',
    icon: '🤝',
    title: "Approche Collaborative Transparente",
    description: "Votre projet est notre projet. Nous travaillons en étroite collaboration avec vous à chaque étape, en assurant une communication claire et régulière."
  },
  {
    id: 'vp3',
    icon: '🛠️',
    title: "Expertise Full-Stack Polyvalente",
    description: "De la conception UX/UI au développement backend complexe et au déploiement, notre équipe maîtrise l'ensemble de la chaîne de production web."
  },
  {
    id: 'vp4',
    icon: '🌟',
    title: "Engagement Qualité & Support",
    description: "Nous nous engageons à livrer des produits de haute qualité, testés rigoureusement, et à vous fournir un support réactif pour assurer votre satisfaction à long terme."
  }
];

function ValuePropositionSection() {
  return (
    <section className="value-proposition-section">
      <h2 className="section-title">Pourquoi nous faire confiance ?</h2>

      <Swiper
        modules={[Navigation, Pagination, Autoplay, A11y]}
        spaceBetween={30}
        slidesPerView={1}
        loop={valuePoints.length > 2}
        centeredSlides={false}
        grabCursor={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          // ASSUREZ-VOUS QUE CECI EST BIEN À FALSE POUR DES POINTS CLASSIQUES
          dynamicBullets: false, 
          el: '.value-proposition-swiper-pagination'
        }}
        navigation={{
          nextEl: '.value-proposition-swiper-button-next',
          prevEl: '.value-proposition-swiper-button-prev',
        }}
        className="value-points-swiper"
        breakpoints={{
          768: {
            slidesPerView: 2,
            spaceBetween: 25,
            centeredSlides: valuePoints.length > 2,
          },
          1024: {
            slidesPerView: valuePoints.length >= 3 ? 3 : valuePoints.length,
            spaceBetween: 30,
            centeredSlides: valuePoints.length > 3,
          },
        }}
      >
        {valuePoints.map(point => (
          <SwiperSlide key={point.id} className="value-point-swiper-slide">
            <div className="value-point-card">
              <div className="value-point-icon-wrapper">
                <span className="value-point-icon" role="img" aria-label="">{point.icon}</span>
              </div>
              <div className="value-point-content">
                <h3>{point.title}</h3>
                <p>{point.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="swiper-custom-controls-vp">
          <div className="value-proposition-swiper-button-prev swiper-nav-button-vp" aria-label="Point précédent">
            ❮
          </div>
          <div className="value-proposition-swiper-pagination swiper-custom-pagination-vp"></div>
          <div className="value-proposition-swiper-button-next swiper-nav-button-vp" aria-label="Point suivant">
            ❯
          </div>
        </div>
      </Swiper>
    </section>
  );
}

export default ValuePropositionSection;